export default "__VITE_ASSET__DoUaoP0h__"